<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Product List</h3>
              <router-link
                :to="{ path: 'products/create' }"
                class="float-right mt-0"
              >
                <v-tooltip
                  bottom
                  :color="$vuetify.theme.themes.light.tooltipColor"
                >
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add Product</span>
                </v-tooltip>
              </router-link>
            </div>

            <v-card>
              <v-card-title>
                <v-container style="margin: 0px;max-width: 100%;">
                  <v-row>
                  <v-col>
                    <v-text-field
                      class="search-text-field"
                      v-model="search"
                      append-icon="search"
                      label="Search by Name"
                      single-line
                      hide-details
                      v-debounce:1s="searchFilter"
                      :debounce-events="['click', 'keydown']"
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <v-select
                      :items="manufacturersList"
                      item-value="_id"
                      item-text="name"
                      label="Select Brand"
                      v-model="manufacturer"
                      @change="manufacturerFilter"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-select
                      :items="statusArr"
                      item-value="value"
                      item-text="name"
                      label="Select Status"
                      v-model="status"
                      @change="statusFilter"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      :items="apiOptions"
                      item-value="value"
                      item-text="name"
                      label="Formulation/Mode of Administration"
                      v-model="api"
                      @change="apiFilter"
                    ></v-select>
                  </v-col>

                  <v-col style="display: flex; align-items: center;gap: 12px;">

                    <v-text-field
                      v-model="productPrice"
                      label="Enter Price"
                      type="number"
                      v-debounce:1s="productPriceNumberFilter"
                      :debounce-events="['click', 'keydown']"
                      style="font-weight: 400;"
                    ></v-text-field>

                    <v-select
                      v-model="productPriceOperator"
                      :items="priceOperatorOptions"
                      item-value="value"
                      item-text="name"
                      label="Price Operator"
                      class="mr-4"
                      @change="productPriceFilter"
                      style="max-width: 150px;"
                    />

                    <v-btn
                      color="#344452"
                      class="white--text"
                      style="margin-top: -14px;"
                      @click="printList"
                    >Print List</v-btn>
                  </v-col>
                </v-row>


                </v-container>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="products"
                :loading="loading"
                loading-text="Loading... Please wait"
                :server-items-length="products.length"
                @update:page="initialize()"
                @update:items-per-page="initialize()"
                @update:sort-by="initialize()"
                @update:sort-desc="initialize()"
                :options.sync="options"
                hide-default-footer
              >
                <template v-slot:[`item.stockStatus`]="props">
                  <v-select
                    :items="stockStatusArr"
                    item-value="value"
                    item-text="name"
                    @change="changeAvailability(props.item)"
                    label="Select Availability"
                    v-model="props.item.stockStatus"
                    single-line
                    style="width: 200px"
                  ></v-select>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                  <div style="width: 250px">{{ item.name }}</div>
                </template>

                <template v-slot:[`item.manufacturersObj.name`]="{ item }">
                  <div>
                    {{
                      item.manufacturersObj && item.manufacturersObj.name
                        ? item.manufacturersObj.name
                        : "-"
                    }}
                  </div>
                </template>

                <template v-slot:[`item.brandsObj.name`]="{ item }">
                  <div>
                    {{
                      item.brandsObj && item.brandsObj.name
                        ? item.brandsObj.name
                        : "-"
                    }}
                  </div>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                  <div style="width: 100px">{{ item.status === 1 ? 'Published' : 'Draft' }}</div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'products/edit/' + item._id }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <v-icon
                          medium
                          class="mr-2 edit-icon"
                          size="30"
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          >mdi-pencil-outline</v-icon
                        >
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>

                  <delete-component
                    :id="item._id"
                    module="product/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2">
                <v-pagination
                  circle
                  v-model="options.page"
                  :length="options.pageCount"
                ></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import { ProductService } from "@/services";

export default {
  name: "Products",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 50,
      pageCount: 0,
    },
    search: "",
    products: [],
    status: 1,
    manufacturer: null,
    manufacturersList:[],
    api: null,
    productPriceOperator: "eq",
    productPrice: null,

    statusArr: [
      {
        name: "All",
        value: "all",
      },
      {
        name: "Draft",
        value: 3,
      },
      {
        name: "Published",
        value: 1,
      },
    ],
    stockStatusArr: [
      {
        name: "Available in 1 week",
        value: "Available in 1 week",
      },
      {
        name: "Available in 2 weeks",
        value: "Available in 2 weeks",
      },
      {
        name: "Available in 3 weeks",
        value: "Available in 3 weeks",
      },
      {
        name: "Available in 4 weeks",
        value: "Available in 4 weeks",
      },
      {
        name: "Coming Soon",
        value: "Coming Soon",
      },
      {
        name: "Low Stock",
        value: "Low Stock",
      },
      {
        name: "In Stock",
        value: "In Stock",
      },
      {
        name: "Out of Stock",
        value: "Out of Stock",
      },
    ],
    headers: [
      {
        text: "Name",
        align: "start",
        value: "name",
      },
      { text: "Availability", value: "stockStatus" },
      { text: "Cultivator", value: "manufacturersObj.name" },
      { text: "Brand", value: "brandsObj.name" },
      { text: "Status", value: "status" },
      { text: "Mode of Administration", value: "modeOfAdministration" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    apiOptions: [
        {
          name: "Sublingual oil",
          value: "Sublingual oil",
        },
        {
          name: "Sublingual/oral pastilles",
          value: "Sublingual/oral pastilles",
        },
        {
          name: "Sublingual/oral lozenges",
          value: "Sublingual/oral lozenges",
        },
        {
          name: "Flower for vaporisation",
          value: "Flower for vaporisation"
        },
        {
          name: "Oil in prefilled vape cartridge",
          value: "Oil in prefilled vape cartridge"
        },
        {
          name: "Loose extracts for vaporisation",
          value: "Loose extracts for vaporisation"
        },
        {
          name: "Sublingual/buccal spray",
          value: "Sublingual/buccal spray"
        },
        {
          name: "Suppository (PR)",
          value: "Suppository (PR)"
        },
        {
          name: "Vaginal pessary/Suppository (PV)",
          value: "Vaginal pessary/Suppository (PV)"
        },
        {
          name: "Transdermal patch",
          value: "Transdermal patch"
        },
        {
          name: "Topical cream",
          value: "Topical cream"
        },
        {
          name: "Sublingual strip",
          value: "Sublingual strip"
        },
        {
          name: "Other",
          value: "Other"
        }
      ],
      priceOperatorOptions: [
        {
          name: "Less Than",
          value: "lt",
        },
      {
          name: "Greater Than",
          value: "gt",
        },
      {
          name: "Equal To",
          value: "eq",
        },
      ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  async mounted() {
    // Get Manufacturer
    this.manufacturersList = [{
        name: "All",
        _id: null,
      }];
      const response = await ProductService.getManufacturNameList();
      console.log(response.data);
      if (response.data) {
        this.manufacturersList = [...this.manufacturersList,...response.data];
      }
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.options.itemsPerPage),
        skip:
          parseInt(this.options.page) * parseInt(this.options.itemsPerPage) -
          parseInt(this.options.itemsPerPage),
        name: this.search,
        manufacturer: this.manufacturer !== null ? this.manufacturer : null,
        sortName: this.options.sortBy && this.options.sortBy[0],
        sortBy: this.options.sortDesc && this.options.sortDesc[0],
        status: this.status,
        api: this.api,
        productPriceFilter: this.productPriceOperator,
        productPrice: this.productPrice,
      };

      const products = await ProductService.productList(params);
      if (products.data.data.length > 0) {
        this.options.pageCount = Math.ceil(
          products.data.option[0].count / this.options.itemsPerPage
        );
        this.products = products.data.data;
        this.loading = false;
      } else {
        if (this.options.page !== 1) {
          this.options.page--;
        }
        this.loading = false;
        this.products = [];
      }
    },
    async handleClick(value) {
      this.$router.push("/products/edit/" + value._id);
    },
    searchFilter() {
      this.options.page = 1;
      this.initialize();
    },
    statusFilter() {
      this.options.page = 1;
      this.initialize();
    },
    manufacturerFilter(){
      this.options.page = 1;
      this.initialize();
    },
    async changeAvailability(product) {
      const obj = {
        stockStatus: product.stockStatus,
        status: product.status,
        modeOfAdministration: this.modeOfAdministration,
      };
      try {
        const response = await ProductService.update({
          id: product._id,
          object: obj,
        });
        if (response) {
          this.$store.dispatch("user/setSnack", "Availability Updated.");
          this.$store.dispatch("user/setType", "info");
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
        this.loading = false;
      }
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
    apiFilter(){
      this.options.page = 1;
      this.initialize();
    },
    productPriceFilter(){
      this.options.page = 1;
      this.initialize();
    },
    productPriceNumberFilter(){
      this.options.page = 1;
      this.initialize();
    },

    async printList(){
      const params = {
        name: this.search,
        manufacturer: this.manufacturer !== null ? this.manufacturer : null,
        sortName: this.options.sortBy && this.options.sortBy[0],
        sortBy: this.options.sortDesc && this.options.sortDesc[0],
        status: this.status,
        api: this.api,
        productPriceFilter: this.productPriceOperator,
        productPrice: this.productPrice,
      };

      const response = await ProductService.exportProductList(params);
      const url = window.URL.createObjectURL(new Blob([response.data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.$store.dispatch("user/setSnack", "Exported Successfully.");
      this.$store.dispatch("user/setType", "info");
    },
  },
};
</script>
